import { render, staticRenderFns } from "./ControllerBar.vue?vue&type=template&id=4111570a&scoped=true&"
import script from "./ControllerBar.vue?vue&type=script&lang=js&"
export * from "./ControllerBar.vue?vue&type=script&lang=js&"
import style0 from "./ControllerBar.vue?vue&type=style&index=0&id=4111570a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4111570a",
  null
  
)

export default component.exports